module.exports = __webpack_public_path__ + "img/3S.9638bf9f.png";